import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'list_page' */ './ProfitItemsListPage'),
);
